import React from 'react'
import { Link } from 'react-router'
import ThemeToggle from '../components/ThemeToggle'

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="text-6xl mb-4">🤖</div>
          <h1 className="text-6xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-2">
            Pagina niet gevonden
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            De pagina die je zoekt bestaat niet of is verplaatst.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="btn btn-primary w-full"
          >
            Terug naar home
          </Link>
          <Link
            to="/#meetups"
            className="btn btn-outline w-full"
          >
            Bekijk meetups
          </Link>
        </div>

        <div className="mt-8 text-sm text-gray-500 dark:text-gray-400">
          <p>
            Denk je dat dit een fout is?{' '}
            <a
              href={`mailto:info@${import.meta.env.ORGANIZATION_NAME?.toLowerCase() || 'techclub'}.nl`}
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-500 transition-colors"
            >
              Laat het ons weten
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default NotFound